// usage:
// inside Vue components:
// this.$log.info()
// 
// elsewhere: 
// import {log} from '@/service/log'
// log.info()

import Vue from 'vue'
import { db, fb } from '@/globals'
import store from '@/store'
import Cart from '@/cart'

// forward logs elsewhere
async function dispatch(args) {
  
  if (args.level == 'error') {
    // dispatch error to store error collector
    store.commit({
      type: 'logging/collectError',
      error: args
    })
  }
  
  // dispatch error to current cart in firestore
  if (args.tags.includes('logToCart')) {
    await db.collection(`shops/${Cart.shopId}/carts/${Cart.cartId}/logging`)
    .add({
      ...args,
      meta: {
        created: fb.firestore.FieldValue.serverTimestamp(),
        createdOnClient: new Date()
      }
    })
  }
  
}


// process log and output to console
function process(args) {
  var level = args.level
  var config = null
  var payload = null
  var tags = null
  var path = null
  var evaluateImmediately = true

  // process config
  if (typeof args.args[0] === 'object' && ['path', 'fn', 'tags'].some(r => Object.keys(args.args[0]).includes(r))) {
    config = args.args[0]
    
    if (config.path || config.fn) {
      path = config.path
      path += config.path && config.fn ? '/' : ''
      path += config.fn ? config.fn : ''
      path += ':'
    }
    
    if (config.tags) {
      tags = config.tags
    }
    
    payload = args.args.slice(1)
  } else {
    payload = args.args
  }

  if (evaluateImmediately) {
    payload = JSON.parse(JSON.stringify(payload))
  }

  // console output
  if (level == 'event') {
    if (path) {
      console.log(path, ...payload)
    } else {
      console.log(...payload)
    }
    
  } else {
    if (path) {
      console[level](path, ...payload)
    } else {
      console[level](...payload)
    }
  }
  
  dispatch({
    level,
    path,
    tags,
    payload
  })
}



export const log = {
  event: (...args) => process({level: 'event', args}),
  info: (...args) => process({level: 'info', args}),
  warn: (...args) => process({level: 'warn', args}),
  error: (...args) => process({level: 'error', args}),
  debug: (...args) => process({level: 'debug', args})
}